import React from 'react';
import { Skeleton } from '@material-ui/lab';

import LineChartPlaceholder from './LineChartPlaceHolder';

import Styles from './styles.module.scss';

const LineChartSkeleton = () => {
    return (
        <div className={Styles.Loading}>
            <div className={Styles.LoadingContent}>
                <LineChartPlaceholder />
                <p className={Styles.SkeletonBar}>
                    <Skeleton variant={'rect'} height={'100%'} width={'100%'} />
                </p>
            </div>
        </div>
    );
};

export default LineChartSkeleton;
